/*
 * @Description: 用户部分 --vuex
 * @Author: ywl
 * @Date: 2021-03-05 09:51:12
 * @LastEditors: mx 1040698446@qq.com
 * @LastEditTime: 2024-09-29 11:22:20
 */
import userApis from '@/api/modules/user';
import { Tool } from '@/utils/tool';
import { getSubName } from '@/utils/getHost';
const tool = new Tool();
const NODE_ENV = process.env.NODE_ENV;
const tokenName = 'LyxUserToken';
export default {
  namespaced: true,
  state: {
    userInfo: {
      headImg: '',
      memberLevel: 1,
      openId: '',
      username: '',
      balance: 0,
      intro: false,
      expDate: null,
      memberTime: null,
      memberUpgradeType: null,
    },
  },
  getters: {
    getToken: () => () => tool.getCookie(tokenName),
    isLogin: () => () => !!tool.getCookie(tokenName),
    userInfo: (state: any) => state.userInfo,
  },
  mutations: {
    SET_USER_INFO: (state: any, payload: any) => {
      // console.log('存储');
      state.userInfo = payload;
    },
  },
  actions: {
    /**
     * @description: 登录
     * @param {any} {commit}
     * @param {any} payload
     * @return {*} Promise
     */
    login({ commit }: any, payload: any) {
      return new Promise((resolve, reject) => {
        if (payload) {
          userApis
            .login(payload)
            .then((res: any) => {
              commit('SET_USER_INFO', res);
              if (NODE_ENV == 'development') {
                tool.setCookie(tokenName, res.token, 7, window.location.hostname);
              }
              if (getSubName() == 'longyixiu') {
                tool.setCookie(tokenName, res.token, 7, process.env.VUE_APP_COOKIE_DOMAIN);
              } else if (getSubName() == 'wenjuanjia') {
                tool.setCookie(tokenName, res.token, 7, '.wenjuanjia.com');
              }
              resolve(res);
            })
            .catch((err: any) => {
              reject(err);
            });
        }
      });
    },
    /**
     * @description: 获取用户信息
     * @param {any} {commit}
     * @return {*} Promise
     */
    getUserInfo({ commit }: any) {
      return new Promise((resolve, reject) => {
        userApis
          .getUserInfo()
          .then((res: any) => {
            commit('SET_USER_INFO', {
              ...res,
              // aiCoin: 0,
              // messageNumber: 1,
              // phone: '',
              // username: '用户123456',
              // openId: '',
              // advertSize:0,
              // surplusAdvertSize:0,
              // entrySize: 0
              // memberLevel: 4,
              // memberUpgradeType: 3,
            });

            resolve(res);
          })
          .catch((err: any) => {
            reject(err);
          });
      });
    },
    /**
     * @description: 注册
     * @param {any} commit
     * @param {any} payload
     * @return {*} Promise
     */
    register({ commit }: any, payload: any) {
      return new Promise((resolve, reject) => {
        userApis
          .register(payload)
          .then((res: any) => {
            commit('SET_USER_INFO', res);
            if (NODE_ENV == 'development') {
              tool.setCookie(tokenName, res.token, 7, window.location.hostname);
            }
            if (getSubName() == 'longyixiu') {
              tool.setCookie(tokenName, res.token, 7, process.env.VUE_APP_COOKIE_DOMAIN);
            } else if (getSubName() == 'wenjuanjia') {
              tool.setCookie(tokenName, res.token, 7, '.wenjuanjia.com');
            }
            resolve(res);
          })
          .catch((err: any) => {
            reject(err);
          });
      });
    },
    /**
     * @description: 绑定微信
     * @param {any} commit
     * @param {any} payload
     * @return {*} Promise
     */
    bindingLogin({ commit }: any, payload: any) {
      return new Promise((resolve, reject) => {
        if (payload) {
          userApis
            .getBindingLogin(payload)
            .then((res: any) => {
              commit('SET_USER_INFO', res);
              if (NODE_ENV == 'development') {
                tool.setCookie(tokenName, res.token, 7, window.location.hostname);
              }
              if (getSubName() == 'longyixiu') {
                tool.setCookie(tokenName, res.token, 7, process.env.VUE_APP_COOKIE_DOMAIN);
              } else if (getSubName() == 'wenjuanjia') {
                tool.setCookie(tokenName, res.token, 7, '.wenjuanjia.com');
              }
              resolve(res);
            })
            .catch((err: any) => {
              reject(err);
            });
        }
      });
    },
    /**
     * @description: 绑定微信信息
     * @param {any} commit
     * @param {any} info
     * @return {*} Promise
     */
    bindingInfo({ commit }: any, res: any) {
      return new Promise((resolve, reject) => {
        if (res) {
          commit('SET_USER_INFO', res);
          if (NODE_ENV == 'development') {
            tool.setCookie(tokenName, res.token, 7, window.location.hostname);
          }
          if (getSubName() == 'longyixiu') {
            tool.setCookie(tokenName, res.token, 7, process.env.VUE_APP_COOKIE_DOMAIN);
          } else if (getSubName() == 'wenjuanjia') {
            tool.setCookie(tokenName, res.token, 7, '.wenjuanjia.com');
          }
          resolve(res);
        }
      });
    },
    /**
     * @description: 退出登录
     * @return {*} Promise
     */
    logout({ commit }: any) {
      return new Promise((resolve) => {
        commit('SET_USER_INFO', {
          headImg: '',
          memberLevel: 0,
          openId: '',
          username: '',
          balance: 0,
          intro: false,
          expDate: null,
        });

        tool.deleteCookie(tokenName, window.location.hostname);
        if (getSubName() == 'longyixiu') {
          tool.deleteCookie(tokenName, process.env.VUE_APP_COOKIE_DOMAIN);
        } else if (getSubName() == 'wenjuanjia') {
          tool.deleteCookie(tokenName, '.wenjuanjia.com');
        }
        localStorage.clear();
        resolve({});
      });
    },
  },
};
